// App -> Deals -> uniqueRoundsList.js
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../components/ui/checkbox';
import { fetchInvestmentRounds } from './apiService';

const UniqueRoundsList = ({ selectedRounds, setSelectedRounds }) => {
  const { t } = useTranslation();
  
  const [rounds, setRounds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getRounds = async () => {
      try {
        const roundsData = await fetchInvestmentRounds();
        // Filter unique and non-empty values
        const filteredRounds = [...new Set(roundsData)].filter(round => round && round.trim() !== '');
        setRounds(filteredRounds);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    getRounds();
  }, []);

  if (loading) {
    return <p></p>;
  }

  if (error) {
    return <p></p>;
  }

  const handleRoundChange = (checked, value) => {
    if (checked) {
      // Add the selected round
      setSelectedRounds([...selectedRounds, value]);
    } else {
      // Remove the round from selected
      setSelectedRounds(selectedRounds.filter((round) => round !== value));
    }
  };

  return (
    <div className="mt-5 max-h-40 overflow-y-auto">
      {rounds.map((round, index) => (
        <div key={index} className="flex items-center mb-1">
          <Checkbox
            id={`round-${index}`}
            checked={selectedRounds.includes(round)}
            onCheckedChange={(checked) => handleRoundChange(checked, round)}
            className="mr-2 cursor-pointer"
          />
          <label htmlFor={`round-${index}`} className="text-sm">
            {round}
          </label>
        </div>
      ))}
    </div>
  );
};

export default UniqueRoundsList;

